<div class="m-b-20">
  <div class="flexie-auto-grid">
    <!-- Search -->
    <div>
      <div>
        <h3 translate>Search</h3>
        <app-ui-search [(SearchCriteria)]="CRITERIALOOKUP" (componentOutput)="fetchSearchResult($event)"
          searchURL="inbox/searchInbox" itemsPerPage='20' dropdownType='single' [(inboxViewName)]="inboxViewName">
        </app-ui-search>
      </div>
    </div>
    <!-- Inbox Type Switcher: My/Subordinate/Team -->
    <div class="text-a-right">
      <h3>Inbox</h3>
      <nz-radio-group *ngIf="inboxFullPrivilege" [(ngModel)]="radioValue" [nzButtonStyle]="'solid'"
        [nzSize]="'default'">
        <label nz-radio-button nzValue="myCases" (click)="loadCases('myCases')" translate>
          <i nz-icon nzType="user" nzTheme="outline"></i> My Tasks</label>
        <label nz-radio-button nzValue="subCases" (click)="loadCases('subCases')">
          <i nz-icon nzType="usergroup-add" nzTheme="outline" translate></i> Subordinate Tasks</label>
        <label nz-radio-button nzValue="teamCases" (click)="loadCases('teamCases')" translate>
          <i nz-icon nzType="team" nzTheme="outline"></i> Team Tasks</label>
      </nz-radio-group>
    </div>
  </div>
</div>
<div class="inbox-grid">

  <!--Menu Items Block -->
  <div class="inbox-tree">

    <!-- Tree Block -->
    <nz-tree [nzData]="nodes" nzShowIcon="true" (nzClick)="treeClick($event)">
    </nz-tree>

    <!-- Reassign Block -->
    <!-- <div>
      <h5>Reassign Tasks</h5>
      <span class="col-grey d-b">Select tasks to re-assign them</span>
      <a class="d-b" (click)="assingTask()">Reassign selected tasks</a>
    </div> -->

  </div>

  <!-- Items / Inbox Cards Block -->
  <div>

    <!-- <label  nz-radio-button (click)="showAssingModal()" translate>
          <i nz-icon nzType="user" nzTheme="outline">
          </i>Reassign Task
    </label> -->
    <div class="btn-align" style="width: 100%;text-align: end;margin-bottom: 10px">
      <button *ngIf="inboxFullPrivilege" nz-button (click)="showAssingModal()"><i nz-icon nzType="user"
        nzTheme="outline"></i><span>Reassign
          Task</span></button>
    </div>

    

    <div nz-row
      *ngFor="let workQueueItem of (getPageWiseInboxItems(workQueueAPIResponse | SortTaskList: sortCriteria) | async); index as i;">
      <app-inbox-card style="min-width: 100%" (componentOutput)="openTransactionDetails($event)" [InboxType]="_inboxType"
        [inputDataInboxCard]="workQueueItem" [filteredMetaDataMap]="filteredMetaDataMap">
      </app-inbox-card>
    </div>
    <app-generic-zero-ui *ngIf="!isLoading && sortCriteria"
      [list]="(workQueueAPIResponse | SortTaskList: sortCriteria)"></app-generic-zero-ui>
    <app-generic-zero-ui *ngIf="!isLoading && !sortCriteria" [list]="workQueueAPIResponse"></app-generic-zero-ui>
    <ng-container *ngIf="isLoading">
      <div *ngFor="let item of fakeLoadingCards" nz-col nzSpan="24" class="task-item shadowed-on-hover">
        <nz-skeleton *ngFor="let item of fakeLoadingCards" [nzAvatar]="false" [nzActive]="true" [nzTitle]="true"
          [nzLoading]="isLoading"></nz-skeleton>
      </div>
    </ng-container>
  </div>
</div>
<div *ngIf="appMetadataHandler.featureFlags.enablePaginationOnInbox" class="pagination-inbox text-a-center">
  <nz-pagination [nzPageIndex]="pageNumber" [nzTotal]="totalitems" [nzPageSize]="itemsPerPage"
    (nzPageIndexChange)="setCurrentPageNumber($event)"></nz-pagination>
</div>

<!-- <pre *ngIf="!env.production">$Dev Mode Logs: 
  Page Number: {{pageNumber}}
  Data Log: {{(getPageWiseInboxItems(workQueueAPIResponse) | async)|json}}$</pre> -->



<!-- ReAssign component -->

<nz-modal [(nzVisible)]="modShowReassing" nzTitle="Reassign Tasks" (nzOnCancel)="modShowReassing=false"
  (nzOnOk)="assingTask();modShowReassing=false" nzOkText="Assign" nzWidth="600px">
  <ng-container *nzModalContent>
  <div *ngIf="modShowReassing">
    <h4 class="d-b m-t-20">Assign to</h4>
    <!-- //nzMode="tags" -->
    <nz-select nzShowSearch  style="width: 100%;" [(ngModel)]="assingTo">
      <nz-option *ngFor="let item of (lookup$.roleUsers | async) as roleUsers; trackBy:item?.lookupKey"
        [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey">
      </nz-option>
    </nz-select>
  </div>
  </ng-container>

</nz-modal>
